import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { ButtonPlayerProfileRed } from "../generic/common/ButtonPlayerProfileRed";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
var _PlayerProfileCoopInfo = function (_a) {
    var guildName = _a.guildName, guildId = _a.guildId, guildLevel = _a.guildLevel, playerId = _a.playerId, onLeaveCoop = _a.onLeaveCoop;
    return (React.createElement("div", { className: "flex flex--centered flex--top w100 h100" },
        React.createElement("div", { className: IdStyles.PlayerProfileCoopBackground },
            React.createElement("div", { className: "ranking-profile__pic-container w100 h100 flex flex--guts" },
                React.createElement("div", { className: "big-coop-picture big-coop-picture__coop player-profile__picture" },
                    React.createElement(Badge, { position: IdBadgePosition.BottomLeft },
                        React.createElement(Icon, { icon: IdIcon.CoopXpIcn, styleId: IdStyles.IconMedium },
                            React.createElement("div", { className: "flex flex--guts h100" },
                                React.createElement(NumberFormat, { amount: guildLevel, className: IdStyles.TextSmallBoldSecondaryOutline }))))))),
        React.createElement("div", { className: "flex flex--stacked player-profile__name-and-buttons" },
            React.createElement("div", { className: IdStyles.PlayerProfileTextBackground + " " + IdStyles.TextNormal + " player-profile__text-container" }, guildName),
            React.createElement("div", { className: "player-profile__buttons" }, !playerId && (React.createElement(TooltipText, { id: IdLoca.leaveCoop_title, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonPlayerProfileRed, { onClick: onLeaveCoop },
                    React.createElement("div", { className: "h100 w100 flex flex--guts" },
                        React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: IdIcon.LeaveAllianceIcn })))))))));
};
var mapDispatch = function (dispatch) { return ({
    onLeaveCoop: function () { return dispatch(actionModalOpen(IdModal.CoopLeaveConfirm)); },
}); };
export var PlayerProfileCoopInfo = connect(undefined, mapDispatch)(_PlayerProfileCoopInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfileCoopInfo.tsx
// module id = 2876
// module chunks = 3